<script>
export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object,
      required: true
    },
    formatPricing: {
      type: Function,
      required: true
    },
    openEditProductModal: {
      type: Function,
      required: true
    },
    openDeleteProductModal: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      showActions: false
    };
  },
  computed: {
    formattedPricing() {
      return this.formatPricing(this.product.pricing);
    }
  },
  methods: {
    toggleActions() {
      this.showActions = !this.showActions;
    },
    editProduct() {
      this.openEditProductModal(this.product);
      this.showActions = false;
    },
    deleteProduct() {
      this.openDeleteProductModal(this.product);
      this.showActions = false;
    }
  }
};
</script>

<template>
  <div
    class="flex justify-between gap-4 bg-white dark:bg-slate-800 rounded-lg shadow p-4 border border-slate-200 dark:border-slate-700"
  >
    <!-- Col 1: Image or placeholder -->
    <div class="flex-shrink-0">
      <template v-if="product.presigned_image_url">
        <img
          :src="product.presigned_image_url"
          alt="Product Image"
          class="w-32 h-32 object-cover rounded border"
        />
      </template>
      <template v-else>
        <div class="w-32 h-32 bg-slate-200 dark:bg-slate-700 rounded border flex items-center justify-center">
          <span class="text-slate-400 dark:text-slate-500 text-sm">No Image</span>
        </div>
      </template>
    </div>

    <!-- Col 2: Name / Desc / Quantity -->
    <div class="flex flex-col flex-1">
      <div>
        <h3 class="text-lg font-semibold text-slate-900 dark:text-slate-100">
          {{ product.product_name }}
        </h3>
        <p class="text-sm text-slate-700 dark:text-slate-300 mt-1">
          <strong>Description:</strong>
          {{ product.description || '-' }}
        </p>
      </div>
      <p class="text-sm text-slate-700 dark:text-slate-300">
        <strong>Quantity:</strong> {{ product.quantity }}
      </p>
    </div>

    <!-- Col 3: Pricing + More menu -->
    <div class="flex flex-col flex-1 relative">
      <div v-if="product.pricing" class="text-sm text-slate-700 dark:text-slate-300 mb-2">
        <strong>Pricing:</strong>
        <div class="mt-1 space-y-1">
          <div
            v-for="(price, idx) in formattedPricing"
            :key="idx"
          >
            {{ price }}
          </div>
        </div>
      </div>

      <div class="absolute top-0 right-0" @click.stop>
        <button
          @click="toggleActions"
          class="p-1 rounded hover:bg-slate-100 dark:hover:bg-slate-700"
        >
          <fluent-icon icon="more-vertical" />
        </button>

        <!-- Dropdown -->
        <div
          v-if="showActions"
          class="absolute right-0 mt-2 w-32 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded shadow z-50"
        >
          <button
            @click="editProduct"
            class="w-full text-left px-4 py-2 hover:bg-slate-100 dark:hover:bg-slate-700"
          >
            Edit
          </button>
          <button
            @click="deleteProduct"
            class="w-full text-left px-4 py-2 hover:bg-slate-100 dark:hover:bg-slate-700 text-red-600"
          >
            Delete
          </button>
        </div>

        <!-- Backdrop to close -->
        <div
          v-if="showActions"
          class="fixed inset-0 z-40"
          @click="showActions = false"
        ></div>
      </div>
    </div>
  </div>
</template>


